const DONE = 'DONE';
const SET_LAST_DEPOSIT = 'SET_LAST_DEPOSIT';

const state = {
    amount: null,
    date: null
};

const getters = {
    state: state => state 
}

const actions = {
    [DONE]: async ({ state, commit, dispatch }, { amount }) => {
        commit(SET_LAST_DEPOSIT, amount);
    }
};

const mutations = {
    [SET_LAST_DEPOSIT](state, amount) {
        state.amount = amount;     
        state.date = new Date().valueOf();           
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/deposit.js